import React from "react";
import ReactDOM from "react-dom";

import {AppContainer} from "react-hot-loader";

import {Provider} from "react-redux";
import store from "./store/configureStore";

import App from "./App";

import { QueryClientProvider } from "react-query";

import queryClient from "./queries/queryClient";
import { Chart } from "chart.js";
import { getCSSvar } from "./helpers";

import "@fortawesome/fontawesome-free/css/all.min.css";

Chart.defaults.global.defaultFontFamily = getCSSvar("--fonts");
Chart.defaults.global.maintainAspectRatio = false;
Chart.defaults.global.legend.position = 'bottom';

const render = (Component) => {
    ReactDOM.render(
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <AppContainer>
                    <Component/>
                </AppContainer>
            </Provider>
        </QueryClientProvider>,
        document.getElementById('root'),
    )
};
render(App);
if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./App', () => {
        render(App)
    })
}



// WEBPACK FOOTER //
// ./src/index.js